import React from "react";
import Svg, { Path } from "react-native-svg";

type Props = {
  size?: number;
  color?: string;
};

export default function FacebookSvgIcon({
  size = 18,
  color = "#111827",
}: Props) {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <Path
        d="M14.3 8.2h2V5.1c-.35-.05-1.55-.15-2.95-.15-2.9 0-4.85 1.72-4.85 4.9v2.55H5.3v3.45h3.2V24h3.8v-8.15h3.15l.5-3.45H12.3V10.2c0-.98.3-2 2-2Z"
        fill={color}
      />
    </Svg>
  );
}
